import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

type CacheConfigUpdate = components['schemas']['CacheConfigUpdate']

// Update cache configuration
export function useUpdateCacheConfig() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: CacheConfigUpdate) => {
      const { data, error } = await client.PATCH('/api/v1/cache/config', {
        body: params,
      })
      if (error) throw error
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cache.status })
      queryClient.invalidateQueries({ queryKey: queryKeys.cache.config })
    },
  })
}

// Force immediate cache refresh
export function useForceRefresh() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await client.POST('/api/v1/cache/force-refresh')
      if (error) throw error
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cache.status })
    },
  })
}
